const A = "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1200,fit=crop/AQEpDenZyWSpQRW4/";
const P = "https://cdn.zyrosite.com/cdn-cgi/image/format=auto,w=600,h=340,fit=crop,q=100/cdn-ecommerce/store_01J4MKTP3CPJQ62S15GEYPDRB3%2Fassets%2F";

export const assets = {
  logo: "/img/logo-easysistem.png",
  heroBg: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,fit=crop/AQEpDenZyWSpQRW4/436410579f31ae2d99e664554cf0ce2861badfc0-YNqrP39W04fQewNe.jpeg",
  heroQ3x: A + "q3x-n-rt-ant-sd_1-YX4baEwnovF85E4M.webp",
  heroJsmart: A + "jsmart01-5fc5fef0d2f3b-YZ9bxBBJv5CxoPbM.png",
  badge: A + "garanzia12-YBg4PBe5eRt1GqLm.png",
  shopBg: "https://static.prod-images.emergentagent.com/jobs/0153ef93-373d-4bde-b38a-ebf408abf398/images/812fe71556d6858d5d53bff1ed65d36e3244d22f53a73f0d5f829de276d9d018.jpeg",
  gestionali: A + "icona-zh-ant-Yyv7ZlQ2qlCaDJ1V.webp",
  unica: A + "unica2-mxB7Mw1lLaT2oDoP.jpeg",
  silkCircle: A + "silk-windows-ant-new-AVLb1j02oRCqZg77.webp",
  windkey: A + "windkey-lite-3-YX4baEWXR7Sq38oV.webp",
  footerVideo: "https://videos.pexels.com/video-files/4496268/4496268-hd_1920_1080_25fps.mp4",
  footerPoster: "https://images.pexels.com/videos/4496268/background-black-blogger-business-4496268.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=630&w=1200",
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Negozio", to: "/negozio" },
  { label: "Soluzioni", to: "/", hash: "#soluzioni" },
  { label: "Software", to: "/software" },
  { label: "Preventivo", to: "/", hash: "#preventivo" },
  { label: "Assistenza", to: "/assistenza" },
  { label: "Chi siamo", to: "/chi-siamo" },
  { label: "Area Clienti", to: "/area-clienti" },
];

export const legalLinks = ["Privacy Policy", "Cookie Policy", "Termini e Condizioni", "Resi e Rimborsi"];

export const systems = [
  {
    title: "Automazione aziendale e periferiche",
    text: "Sistemi avanzati per l'automazione di ogni settore, per una gestione aziendale più fluida ed economica.",
    image: A + "vs4-77rslwrztbJtQIQc.jpg",
    cta: "Assistenza",
    target: "/assistenza",
  },
  {
    title: "Soluzioni Pos",
    text: "Soluzioni di vendita con schermo touch",
    image: A + "silk-win-4-mp89qwe2bpTjbOnB.webp",
    cta: "Vendita",
    target: "/negozio?cat=poskiosk",
  },
  {
    title: "Bilance Elettroniche",
    text: "Automatizza la tua azienda con precisione",
    image: A + "icona-im-h-01-YNqrP3VNVlurzyxp.webp",
    cta: "Scopri",
    target: "/negozio?cat=bilance",
  },
];

export const categories = [
  { id: "all", label: "Tutti i prodotti" },
  { id: "bilance", label: "Bilance elettroniche" },
  { id: "cassetti", label: "Cassetti Automatici" },
  { id: "misuratori", label: "Misuratori Fiscali" },
  { id: "poskiosk", label: "POS e Kiosk" },
  { id: "stampanti", label: "Stampanti" },
  { id: "accessori", label: "Accessori POS e Kiosk" },
  { id: "software", label: "Software" },
  { id: "tecnologia", label: "Tecnologia Assistenza" },
  { id: "toner", label: "Toner e Consumabili" },
  { id: "usato", label: "Usato come nuovo" },
];

export const products = [
  { id: 1, name: "Registratore di cassa Custom", badge: "923HJ030300U33", oldPrice: 459, price: 400, img: P + "1742032501163-jsmart-n-rt-ant-sd_2.webp", cat: ["misuratori"], date: 12, desc: "Registratore telematico Custom compatto, pronto per l'invio dei corrispettivi all'Agenzia delle Entrate." },
  { id: 2, name: "QD2 DISPLAY CLIENTE QD2 MONO NERO", badge: "932GA030100J33", price: 59, img: P + "1733231695238-qd2-high-01.webp", cat: ["tecnologia"], date: 11, desc: "Display cliente monocromatico nero, ideale per postazioni POS." },
  { id: 3, name: "CASSETTI RENDIRESTO", badge: "971GF010010026", oldPrice: 90, price: 80, img: P + "1733231171559-91a887a907d895d80d142ed3c1544a0f583d6794.webp", cat: ["cassetti"], date: 10, desc: "Cassetto portadenaro robusto con scomparti per banconote e monete." },
  { id: 4, name: "TASTIERA K35 USB", badge: "937DF020400233", price: 80, img: P + "1733230675002-937DF020400233.jpg", cat: ["tecnologia"], date: 9, desc: "Tastiera programmabile USB per sistemi POS." },
  { id: 5, name: "Toner Brother TN2420 compatibile con CHIP 3000 copie", badge: "Nuovo", oldPrice: 15, price: 10.9, img: P + "1732919994447-toner_2.jpg.webp", cat: ["toner"], date: 8, desc: "Toner compatibile con chip, resa 3000 copie." },
  { id: 6, name: "TONER ADJ BR TN247 Compatibile BROTHER", badge: "Novità", oldPrice: 27, price: 19.9, from: true, img: P + "1732918976169-toner_1.jpg.webp", cat: ["toner"], date: 7, desc: "Toner compatibile Brother TN247, disponibile in più colori." },
  { id: 7, name: "Unica", price: null, img: P + "1728043756443-bilancia-elettronica-peso-prezzo-importo-modunica-r-custom-1230-kg-con-stampante-9-operatori-memoria-3.png", cat: ["bilance"], date: 6, desc: "Bilancia elettronica peso-prezzo-importo con stampante, 9 operatori. Prezzo su richiesta." },
  { id: 8, name: "ARAGON PC Pos", badge: "Nuovo", price: 890, from: true, img: P + "1723051499315-1160782839.webp", cat: ["pcpos"], date: 5, desc: "PC POS touch screen professionale per retail e ristorazione." },
  { id: 9, name: "SILK WINDOWS", badge: "Nuovo", price: 899, img: P + "1723050999201-daytona-1.png", cat: ["pcpos", "software"], date: 4, desc: "Postazione POS SILK con sistema operativo Windows." },
  { id: 10, name: "K3-N RT", badge: "Nuova", price: 640, from: true, img: P + "1722977108663-R%20(1).jpg", cat: ["misuratori"], date: 3, desc: "Misuratore fiscale RT compatto e affidabile." },
  { id: 11, name: "Q3X F RT", oldPrice: 530, price: 499, img: P + "1722976905485-q3x-n-rt-ant-sd_1.webp", cat: ["misuratori"], date: 2, desc: "Stampante fiscale RT Q3X con taglierina automatica." },
  { id: 12, name: "SYS@101 ENTRY RT", badge: "Nuovo", oldPrice: 450, price: 410, img: P + "1722975407707-R.jpeg", cat: ["misuratori", "usato"], date: 1, desc: "Registratore di cassa RT entry level, ideale per piccole attività." },
];

export const advanced = [
  { title: "Automazione aziendale completa", text: "Esperti in telefonia, centralini, hardware e software per automatizzare l'azienda a 360 gradi." },
  { title: "Periferiche e accessori", text: "Vendita di accessori, periferiche, misuratori fiscali, stampanti e bilance elettroniche." },
  { title: "Impianti di rete e Wi-Fi", text: "Installazione e ampliamento di impianti di rete e copertura Wi-Fi per aziende." },
];

export const contact = {
  phone: "081 18557973",
  mobile: "333 7870173",
  emailAssist: "assistenza@easysistem.it",
  emailInfo: "info@easysistem.it",
  company: "EasySistem di Raffaele Bianchetti",
  address: "Via Grotta dell'Olmo, 51",
  city: "Giugliano in Campania (Napoli)",
  piva: "04118710617",
  whatsapp: "https://wa.me/3337870173?text=Sarai%20ricontattato%20il%20prima%20possibile.",
  facebook: "https://www.facebook.com/",
  instagram: "https://www.instagram.com/easysistem/",
  tiktok: "https://www.tiktok.com/@easysistem",
  linkedin: "https://www.linkedin.com/",
  x: "https://x.com/",
  map: "https://maps.google.com/maps?q=Via%20Grotta%20dell'Olmo%2051%20Giugliano%20in%20Campania&t=&z=14&ie=UTF8&iwloc=&output=embed",
};

export const fmt = (n) => "€" + Number(n).toFixed(2);
